import { APP_ROUTE } from "../utils/route";

/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations

==========================================================================================*/

const mutations = {
	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////

	// Vertical NavMenu

	TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
		state.isVerticalNavMenuActive = value;
	},
	TOGGLE_REDUCE_BUTTON(state, val) {
		state.reduceButton = val;
	},
	UPDATE_MAIN_LAYOUT_TYPE(state, val) {
		state.mainLayoutType = val;
	},
	UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
		state.verticalNavMenuItemsMin = val;
	},
	UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
		state.verticalNavMenuWidth = width;
	},

	// VxAutoSuggest

	UPDATE_STARRED_PAGE(state, payload) {
		// find item index in search list state
		const index = state.navbarSearchAndPinList.data.findIndex(item => item.index === payload.index);

		// update the main list
		state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

		// if val is true add it to starred else remove
		if (payload.val) {
			state.starredPages.push(state.navbarSearchAndPinList.data[index]);
		} else {
			// find item index from starred pages
			const index = state.starredPages.findIndex(item => item.index === payload.index);

			// remove item using index
			state.starredPages.splice(index, 1);
		}
	},

	// Navbar-Vertical

	ARRANGE_STARRED_PAGES_LIMITED(state, list) {
		const starredPagesMore = state.starredPages.slice(10);
		state.starredPages = list.concat(starredPagesMore);
	},
	ARRANGE_STARRED_PAGES_MORE(state, list) {
		let downToUp = false;
		let lastItemInStarredLimited = state.starredPages[10];
		const starredPagesLimited = state.starredPages.slice(0, 10);
		state.starredPages = starredPagesLimited.concat(list);

		state.starredPages.slice(0, 10).map(i => {
			if (list.indexOf(i) > -1) downToUp = true;
		});

		if (!downToUp) {
			state.starredPages.splice(10, 0, lastItemInStarredLimited);
		}
	},

	// ////////////////////////////////////////////
	// UI
	// ////////////////////////////////////////////

	TOGGLE_CONTENT_OVERLAY(state, val) {
		state.bodyOverlay = val;
	},
	UPDATE_PRIMARY_COLOR(state, val) {
		state.themePrimaryColor = val;
	},
	UPDATE_THEME(state, val) {
		state.theme = val;
	},
	UPDATE_WINDOW_WIDTH(state, width) {
		state.windowWidth = width;
	},
	UPDATE_WINDOW_SCROLL_Y(state, val) {
		state.scrollY = val;
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	// Updates user info in state and localstorage
	UPDATE_USER_INFO(state, payload) {
		// Get Data localStorage
		let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser;

		for (const property of Object.keys(payload)) {
			if (payload[property] != null) {
				// If some of user property is null - user default property defined in state.AppActiveUser
				state.AppActiveUser[property] = payload[property];

				// Update key in localStorage
				userInfo[property] = payload[property];
			}
		}

		// Store data in localStorage
		localStorage.setItem("userInfo", JSON.stringify(userInfo));
	},

	UPDATE_USER_PERMISSIONS(state, payload) {
		state.AppActiveUserPermissions = payload;
	},

	RESET_STORE(state) {
		const initState = {
			AppActiveUser: { uid: 0, first_name: "No Login", status: "online", userRole: "guest" },
			AppActiveUserPermissions: [],
			AppPath: APP_ROUTE.MAIN_APP_ROUTE_PATH + "",
			auth: {
				userPermissions: null,
				isUserLoggedIn: () => {
					return localStorage.getItem("userInfo") && localStorage.getItem("accessToken");
				}
			},
			bodyOverlay: false,
			isVerticalNavMenuActive: true,
			mainLayoutType: "vertical",
			navbarSearchAndPinList: {
				actionIcon: "StarIcon",
				highlightColor: "warning",
				data: [
					{ index: 2, label: "Device", url: APP_ROUTE.MAIN_APP_ROUTE_PATH + "/devices", labelIcon: "CheckSquareIcon", highlightAction: false },
					{ index: 3, label: "Checklist", url: APP_ROUTE.MAIN_APP_ROUTE_PATH + "/checklist", labelIcon: "MessageSquareIcon", highlightAction: false }
				]
			},
			reduceButton: false,
			scrollY: 0,
			starredPages: [],
			theme: "light",
			themePrimaryColor: undefined,
			verticalNavMenuItemsMin: false,
			verticalNavMenuWidth: "default",
			windowWidth: 1346
		};

		Object.assign(state, initState);
	},

	SET_REQUEST_TYPES: (state, requestTypes) => {
		state.requestTypes = requestTypes;
	},
	TOGGLE_NAVBAR(state, val) {
		state.showNavbar = val;
	},

	SET_CATEGORIES: (state, deviceCategories) => {
		// if (!state.deviceCategories || state.deviceCategories.length === 0) {
		state.deviceCategories = deviceCategories;
		// }
	},

	SET_DEPARTMENTS: (state, departments) => (state.departments = departments),

	SET_IS_LOADED_INIT_DATA: (state, isLoadedInitData) => (state.isLoadedInitData = isLoadedInitData),
	UPDATE_STATES(state, states) {
		state.states = states;
	},
	UPDATE_DISTRICTS(state, districts) {
		state.districts = districts;
	},
	UPDATE_WARDS(state, wards) {
		state.wards = wards;
	},
	SET_SYSTEM_TAGS(state, tags) {
		state.systemTags = tags;
	},
	UPDATE_SYSTEM_TAG(state, tag) {
		const tagIndex = state.systemTags.findIndex(t => t.id === tag.id);
		if (tagIndex !== -1) {
			Object.assign(state.systemTags[tagIndex], tag);
		}
	},
	ADD_SYSTEM_TAG(state, tag) {
		state.systemTags.unshift(tag);
	}
};

export default mutations;
